import { Component, HostListener, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { CmsService } from '@spartacus/core';
import { BREAKPOINT, BreakpointService, CmsComponentData } from '@spartacus/storefront';
import { Observable, combineLatest } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-customer-service-section',
  templateUrl: './customer-service-section.component.html',
  styleUrls: ['./customer-service-section.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CustomerServiceSectionComponent implements OnInit {
  customerServiceSection$: Observable<any> = this.componentData.data$;
  customerServiceSectionData$: any;
  activeI = 0;
  customerServiceSectionActive: string;

  isMobile = false;
  cxMobileWidth = this.breakpointService.getSize(BREAKPOINT.sm);

  @Input() data$: Observable<any>;

  constructor(
    private componentData: CmsComponentData<any>,
    private cmsService: CmsService,
    private router: Router,
    private componentService: ComponentService,
    private breakpointService: BreakpointService,
    private storageService: StorageService
  ) {}

  ngOnInit() {
    this.isMobile = window.innerWidth < this.cxMobileWidth;

    this.setCustomerServiceSectionData();
    this.getFirstFaqData();
  }

  setCustomerServiceSectionData() {
    this.customerServiceSectionData$ = this.customerServiceSection$.pipe(
      switchMap((data) =>
        combineLatest(
          data.contents
            .split(' ')
            .map((uid: string) => this.cmsService.getComponentData<any>(uid).pipe(map((d) => ({ ...d }))))
        )
      )
    );
  }

  getFirstFaqData() {
    this.customerServiceSectionData$.pipe(take(1)).subscribe((faqData: any) => {
      const firstFaqData = faqData[0];
      if (!(window.location.href.indexOf('#contact-us') > -1) && firstFaqData.uid.includes('FAQ')) {
        this.componentService.setCustomerServiceContent(firstFaqData);
        sessionStorage.setItem('customer-service-section-active', firstFaqData.uid);
        this.customerServiceSectionActive = firstFaqData.uid;
      } else if (window.location.href.indexOf('#contact-us') > -1 && firstFaqData.uid.includes('ContactUs')) {
        this.componentService.setCustomerServiceContent(firstFaqData);
        sessionStorage.setItem('customer-service-section-active', firstFaqData.uid);
        this.customerServiceSectionActive = firstFaqData.uid;
      }
    });
  }

  onClickCustomerServiceSectionLink(linkData: any, index: number) {
    this.activeI = index;
    if (linkData.contents) {
      this.componentService.setCustomerServiceContent(linkData);
      const linkDataUid = linkData.uid;
      sessionStorage.setItem('customer-service-section-active', linkDataUid);
      this.customerServiceSectionActive = linkDataUid;
    } else {
      if (/^http(?:s)?:\/{2}\S+$/.test(linkData.url)) {
        window.open(linkData.url);
      } else {
        this.router.navigateByUrl(linkData.url);
      }
    }
  }

  refreshSelectedClass() {
    this.customerServiceSectionActive = this.storageService.getSessionStorageItem('customer-service-section-active');
  }

  @HostListener('window:resize')
  onResize(): void {
    this.isMobile = window.innerWidth < this.cxMobileWidth;
  }

  ngOnDestroy() {
    // clear temp sessionStorage
    sessionStorage.removeItem('customer-service-section-active');
  }
}
